import { Controller } from "@hotwired/stimulus"

export default class VideoPlayerController extends Controller {
  static targets = ["poster", "video", "feedback"]
  static values  = { path: String }

  declare readonly posterTarget:   HTMLElement
  declare readonly videoTarget:    HTMLVideoElement
  declare readonly feedbackTarget: HTMLElement
  declare readonly pathValue:      string

  private feedbackTimer: ReturnType<typeof setTimeout> | null = null

  async tap() {
    const video = this.videoTarget

    if (video.style.display === "none") {
      await this.loadAndPlay()
      return
    }

    if (video.paused) {
      video.play().catch(() => {})
      this.flash("▶")
    } else {
      video.pause()
      this.flash("⏸")
    }
  }

  private async loadAndPlay() {
    const res  = await fetch(this.pathValue, { headers: { Accept: "application/json" } })
    const data = await res.json() as { url: string }

    const video = this.videoTarget
    video.src   = data.url
    video.style.display = "block"
    this.posterTarget.style.display = "none"
    video.play().catch(() => {})
  }

  private flash(icon: string) {
    const wrapper  = this.feedbackTarget
    const iconEl   = wrapper.querySelector<HTMLElement>(".feedback-icon")
    if (iconEl) iconEl.textContent = icon

    wrapper.classList.remove("opacity-0")
    wrapper.classList.add("opacity-100")

    if (this.feedbackTimer) clearTimeout(this.feedbackTimer)
    this.feedbackTimer = setTimeout(() => {
      wrapper.classList.remove("opacity-100")
      wrapper.classList.add("opacity-0")
    }, 500)
  }
}
